import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { Store } from '@ngxs/store';

@Injectable()
export class CitoModuleGuard implements CanActivate {

  constructor(private router: Router, private store: Store) { }

  canActivate = (): boolean => {
    const hasSelectedModule = this.store.selectSnapshot<boolean>((state: any) => state.dashboard.moduleChosen);

    if (hasSelectedModule) {
      return true;
    }
    else {
      this.router.navigate(['/dashboard']);
    }
  }
}
